export const employeeConstants = {
    GET_REQUEST: 'GET_EMPLOYEE_LIST',
    GET_SUCCESS: 'GET_EMPLOYEE_SUCCESS',
    GET_FAILURE: 'GET_EMPLOYEE_FAILURE',

    ADD_SUCCESS: 'ADD_EMPLOYEE_SUCCESS',
    ADD_FAILURE: 'ADD_EMPLOYEE_FAILURE',

    UPDATE_SUCCESS: 'UPDATE_EMPLOYEE_SUCCESS',
    UPDATE_FAILURE: 'UPDATE_EMPLOYEE_FAILURE',

    DELETE_SUCCESS: 'DELETE_EMPLOYEE_SUCCESS',
    DELETE_FAILURE: 'DELETE_EMPLOYEE_FAILURE',

    CLEAR_ERROR: 'CLEAR_EMPLOYEE_ERROR_CODE'
};